import { UserRepository } from "./user/UserRepository";
import { ArtworkRepository } from './artwork/ArtworkRepository';
import { ArtistRepository } from './artist/ArtistRepository';
import { CountryRepository } from './country/CountryRepository';
import { TranslationRepository } from './translation/TranslationRepository';
import { GalleryRepository } from './galleries/GalleryRepository';
import { SearchRepository } from './search/SearchRepository';
import { ReceiptRepository } from './receipt/ReceiptRepository';

export const RepositoryFactory = {
  users: () => new UserRepository(),
  artworks: () => new ArtworkRepository(),
  artists: () => new ArtistRepository(),
  countries: () => new CountryRepository(),
  translations: () => new TranslationRepository(),
  galleries: () => new GalleryRepository(),
  search: () => new SearchRepository(),
  receipts: () => new ReceiptRepository()
}